/**
 * Credit visibility helpers (visibilidad §4).
 *
 * A billable AI response carries `credits: { charged, balance }`. Call
 * `notifyCreditsCharged` at each call site that processes such a response to
 * broadcast the new balance so the always-visible badge refreshes. The badge
 * shows a transient "−N" flash when charged > 0; BYOK calls charge 0.
 */

// Window event the credit badge listens to. Detail: { charged, balance }.
export const CREDITS_UPDATED_EVENT = 'creditsUpdated';

// Window event that opens the credits modal (fired from the 402 "buy credits"
// invite so any blocked AI action can send the user straight to the packages).
export const OPEN_CREDITS_EVENT = 'openCredits';

/** Open the credits panel from anywhere (e.g. a 402 "buy credits" CTA). */
export function openCreditsPanel() {
  window.dispatchEvent(new Event(OPEN_CREDITS_EVENT));
}

const nf = new Intl.NumberFormat('es-MX');

/** Format an integer credit amount with es-MX grouping. */
export function formatCredits(n) {
  return nf.format(Number(n || 0));
}

/**
 * Broadcast a fresh balance (badge shows a transient "−N" flash on charge).
 * @param {{charged?: number, balance?: number}|null|undefined} credits
 */
export function notifyCreditsCharged(credits) {
  if (!credits || typeof credits.balance !== 'number') return;
  window.dispatchEvent(
    new CustomEvent(CREDITS_UPDATED_EVENT, { detail: credits })
  );
}
